import React from 'react';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import { StatusManager } from 'common/components/StatusManager';
import { ENDPOINTS } from 'features/quick-entry/constants';
import { useFetchWithStatusV2 } from 'hooks/fetchWithStatus';
import { SECONDARY_API_CLIENT } from 'services/API';
import strings from 'strings';

import { LoaderContainer, useStyles } from './QuickEntrySelectionDialog.styled';

const COPIES = strings.inventory.quickEntry.modal;

export const QuickEntrySelectionDialog = ({ onClose, onSelect, open }) => {
  const classes = useStyles();

  const { state } = useFetchWithStatusV2({
    apiInstance: SECONDARY_API_CLIENT,
    endpoint: ENDPOINTS.quickEntryTypes
  });
  const availableQuickEntryTypes = state?.results || [];

  const handleClose = (_event, reason) => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;

    onClose && onClose();
  };

  const handleSelectEntity = newEntity => {
    onSelect && onSelect({ entity: newEntity?.id, notesTemplate: newEntity?.template });
    handleClose();
  };

  return (
    <Dialog
      classes={{ paper: classes.dialogPaper }}
      fullWidth
      maxWidth="md"
      onClose={handleClose}
      open={open}
      scroll="paper"
    >
      <Box className={classes.header}>
        <Box alignItems="center" display="flex" flexDirection="row" gridGap={8}>
          <Typography variant="h6">{COPIES.title}</Typography>
        </Box>
        <IconButton size="small" onClick={handleClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>

      <DialogContent className={classes.dialogContent}>
        <StatusManager
          status={state.status}
          slots={{
            Empty: (
              <Typography paragraph gutterBottom>
                {COPIES.emptyState}
              </Typography>
            ),
            Error: (
              <Typography paragraph gutterBottom>
                {COPIES.error}
              </Typography>
            ),
            Loading: (
              <LoaderContainer>
                <CircularProgress />
              </LoaderContainer>
            )
          }}
        >
          <Typography variant="subtitle1">{COPIES.subtitle}</Typography>
          <Box display="flex" flexWrap="wrap" gridGap={16} marginTop={3}>
            {availableQuickEntryTypes.map(quickEntryType => (
              <Box
                key={quickEntryType?.id}
                className={classes.optionContainer}
                component="button"
                onClick={() => handleSelectEntity(quickEntryType)}
              >
                <Typography variant="subtitle1">{quickEntryType?.title}</Typography>
                <Typography variant="body2">{quickEntryType?.description}</Typography>
              </Box>
            ))}
          </Box>
        </StatusManager>
      </DialogContent>
    </Dialog>
  );
};
